import _ from 'underscore';
import edm from '@bingads-webui-component-legacy/edm-campaign/index';
import { defineGridPlugin } from '@bingads-webui/projection-grid-plugin';
import { getLoadDirectlyLinkedAccountsPreference, setLoadDirectlyLinkedAccounts } from '@bingads-webui-component-legacy/bingads-grid/service/linked-accounts-preferences';

const selectorId = 'accountsSelection_selector';

export default defineGridPlugin('customerHierarchy', [
  'dataSource',
  'gridView',
  'config',
  'toolbar',
], (
  dataSource,
  gridView,
  config,
  toolbar,
) => {
  const originalQuery = dataSource.query;
  const gridName = config.name;
  const { isForVNext, i18n } = _.result(config.plugins, 'customerHierarchy', {});

  dataSource.query = (params) => {
    return getLoadDirectlyLinkedAccountsPreference(gridName).then(({ loadDirectlyLinkedAccounts }) => {
      const options = params.options;
      let queryParams = params;

      if (options.entitySet) {
        const entitySet = edm.root.identifyEntitySet(options.entitySet.toJSON());
        const action = entitySet.navigation.source;
        const { parameters } = entitySet.navigation;

        _.extend(parameters, { isCustomerHierachyRequest: true, loadDirectlyLinkedAccounts });
        queryParams = _.defaults({
          options: _.defaults({
            entitySet: action.$call(parameters),
          }, options),
        }, queryParams);
      }

      gridView.set({ queryParams });
      return originalQuery.call(dataSource, queryParams);
    });
  };

  if (isForVNext) {
    const toolbarEditor = toolbar.gridToolbarGroup.toolbarWithItem();

    const menuItems = {
      showAllAccounts: {
        key: 'accountsSelection_showAllAccounts',
        text: i18n.getString('AccountsSelection_showAllAccounts'),
        loadDirectlyLinkedAccounts: false,
      },
      showDirectlyLinkedAccounts: {
        key: 'accountsSelection_showLinkedAccounts',
        text: i18n.getString('AccountsSelection_showDirectlyLinkedAccounts'),
        loadDirectlyLinkedAccounts: true,
      },
    };

    const items = _.map(menuItems, ({ key, text, loadDirectlyLinkedAccounts }) => ({
      key,
      text,
      onClick: () => {
        toolbarEditor.update({
          id: selectorId,
          button: { text },
        });

        setLoadDirectlyLinkedAccounts(gridName, loadDirectlyLinkedAccounts.toString()).then(() => {
          gridView.refresh(true);
        });
      },
    }));

    getLoadDirectlyLinkedAccountsPreference(gridName).then(({ loadDirectlyLinkedAccounts: rawValue }) => {
      // Due to the way the value is set, it can be a string or a bool.
      const loadDirectlyLinkedAccounts = _.isBoolean(rawValue) ? rawValue : rawValue === 'true';
      const customerHierarchySelector = {
        id: selectorId,
        type: 'dropdown',
        button: {
          text: _.findWhere(menuItems, { loadDirectlyLinkedAccounts }).text,
        },
        menu: {
          items,
        },
      };

      toolbarEditor.update(customerHierarchySelector);
    });
  }
});
